import React from 'react';
import { Link } from 'gatsby';
import { LOGO_PREMIUM } from 'assets/icons/icons';
import { AppRoute } from 'app/app.route.const';

export const PremiumLogoHeader = ({
  link,
  logo = LOGO_PREMIUM,
  maxWidth = '320px',
}: {
  link: AppRoute;
  logo?: string;
  maxWidth?: string | null;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: maxWidth ?? '',
        margin: '24px auto',
      }}
    >
      <Link to={link}>
        <img
          style={{ width: '100%', maxHeight: '30px', objectFit: 'contain', padding: '0 8px' }}
          src={logo}
          alt="logo"
          loading="lazy"
        />
      </Link>
    </div>
  );
};
